import { useState, useEffect } from 'react';
import { getClientesInactivos, reactivarCliente } from '../../services/clienteService';
import { useNavigate } from 'react-router-dom';
import {
    Snackbar,
    Alert,
    Pagination,
} from '@mui/material';
import PageHeader from '../../components/ui/PageHeader';
import { apellidoNombre } from '../../utils/nombrePersona';
import useBreakpoint from '../../hooks/useBreakpoint';
import BottomSheet from '../../components/mobile/BottomSheet';
import BotonFiltros from '../../components/mobile/BotonFiltros';
import ChipsFiltros from '../../components/mobile/ChipsFiltros';
import { formatCuil } from '../../utils/formatCuil';

function ListadoClientesInactivos() {
    const [clientes, setClientes] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(true);
    const [filtroCuil, setFiltroCuil] = useState('');
    const [filtroNombreApellido, setFiltroNombreApellido] = useState('');
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [sheetFiltrosAbierto, setSheetFiltrosAbierto] = useState(false);
    const { esMobile } = useBreakpoint();

    // 🔹 Modal
    const [modalOpen, setModalOpen] = useState(false);
    const [observacion, setObservacion] = useState('');
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

    const navigate = useNavigate();

    const cargarClientes = async () => {
        setLoading(true);
        try {
            const data = await getClientesInactivos(page, 15, filtroCuil, filtroNombreApellido);
            setClientes(data.content || []);
            setTotalPages(data.totalPages || 0);
        } catch (e) {
            setSnackbar({ open: true, message: 'Error al cargar clientes inactivos', severity: 'error' });
        }
        setLoading(false);
    };

    useEffect(() => {
        cargarClientes();
    }, [page, filtroCuil, filtroNombreApellido]);



    const verDetalleCliente = (cuil) => navigate(`/clientes/vista-detallada/${cuil.toString()}`);

    // 🔹 Abrir modal
    const abrirModalReactivar = (cliente) => {
        setClienteSeleccionado(cliente);
        setObservacion(cliente.observacion || '');
        setModalOpen(true);
    };

    // 🔹 Confirmar reactivación
    const confirmarReactivar = async () => {
        if (!clienteSeleccionado) return;
        try {
            await reactivarCliente(clienteSeleccionado.cuil, observacion);
            setSnackbar({ open: true, message: 'Cliente reactivado con éxito', severity: 'success' });
            setModalOpen(false);
            setPage(0);
        } catch (error) {
            setSnackbar({ open: true, message: 'Error al reactivar cliente', severity: 'error' });
        }
    };

    return (
        <div className="area-general">
            <div className="container-fluid p-4" style={{ background: "var(--bg-page)", minHeight: "100vh" }}>
                <div className="container">
                    <PageHeader
                        variante="plano"
                        icono="person-x-fill"
                        titulo="Clientes Inactivos"
                        descripcion="Gestión de clientes dados de baja en el sistema"
                        accion={
                            <button
                                className="btn btn-outline-secondary d-flex align-items-center gap-2 px-3 py-2"
                                onClick={() => navigate('/clientes')}
                                style={{
                                    fontWeight: 600,
                                    borderRadius: "10px"
                                }}
                            >
                                <i className="bi bi-arrow-left"></i>
                                Volver a Activos
                            </button>
                        }
                    />

                {/* Card Principal */}
                <div className="card border-0 shadow-sm" style={{borderRadius: "16px"}}>
                    <div className="card-body p-4">

                        {/* Filtros Modernos */}
                        {(() => {
                            const campoCuil = (
                                <div className="input-group" style={{borderRadius: "10px", overflow: "hidden"}}>
                                    <span className="input-group-text bg-white border-end-0" style={{borderColor: "#e5e7eb"}}>
                                        <i className="bi bi-search text-primary"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 ps-0"
                                        placeholder="Buscar por CUIL"
                                        value={filtroCuil}
                                        maxLength="13"
                                        onChange={(e) => {
                                            setPage(0);
                                            setFiltroCuil(formatCuil(e.target.value));
                                        }}
                                        style={{borderColor: "#e5e7eb"}}
                                    />
                                </div>
                            );
                            const campoNombre = (
                                <div className="input-group" style={{borderRadius: "10px", overflow: "hidden"}}>
                                    <span className="input-group-text bg-white border-end-0" style={{borderColor: "#e5e7eb"}}>
                                        <i className="bi bi-person text-primary"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 ps-0"
                                        placeholder="Buscar por Apellido o Nombre"
                                        value={filtroNombreApellido}
                                        onChange={(e) => {
                                            setPage(0);
                                            setFiltroNombreApellido(e.target.value);
                                        }}
                                        style={{borderColor: "#e5e7eb"}}
                                    />
                                </div>
                            );

                            const chipsFiltros = [
                                filtroCuil && { key: 'cuil', label: `CUIL: ${filtroCuil}`, onQuitar: () => { setPage(0); setFiltroCuil(''); } },
                                filtroNombreApellido && { key: 'nombre', label: filtroNombreApellido, onQuitar: () => { setPage(0); setFiltroNombreApellido(''); } },
                            ].filter(Boolean);

                            return esMobile ? (
                                <div className="mb-4">
                                    <BotonFiltros cantidad={chipsFiltros.length} onClick={() => setSheetFiltrosAbierto(true)} />
                                    <ChipsFiltros chips={chipsFiltros} />
                                    {sheetFiltrosAbierto && (
                                        <BottomSheet
                                            titulo="Filtros"
                                            onCerrar={() => setSheetFiltrosAbierto(false)}
                                            accionPrimaria={chipsFiltros.length > 0 ? { label: 'Limpiar filtros', onClick: () => { setPage(0); setFiltroCuil(''); setFiltroNombreApellido(''); } } : undefined}
                                        >
                                            <div className="mb-3">{campoCuil}</div>
                                            {campoNombre}
                                        </BottomSheet>
                                    )}
                                </div>
                            ) : (
                                <div className="row g-3 mb-4">
                                    <div className="col-md-6">{campoCuil}</div>
                                    <div className="col-md-6">{campoNombre}</div>
                                </div>
                            );
                        })()}

                        {/* Tabla Moderna */}
                        {loading ? (
                            <div className="text-center my-5">
                                <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }}></div>
                                <p className="mt-3 fw-semibold text-muted">Cargando clientes inactivos...</p>
                            </div>
                        ) : (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle">
                                        <thead style={{
                                            background: "var(--gradient-primary-light)",
                                            borderRadius: "8px 8px 0 0"
                                        }}>
                                        <tr>
                                            <th style={{fontWeight: 600, color: "#1e40af", padding: "1rem"}}>CUIL</th>
                                            <th style={{fontWeight: 600, color: "#1e40af", padding: "1rem"}}>Nombre Completo</th>
                                            <th style={{fontWeight: 600, color: "#1e40af", padding: "1rem"}}>Observación</th>
                                            <th className="text-center" style={{fontWeight: 600, color: "#1e40af", padding: "1rem"}}>Acciones</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {clientes.map((c) => (
                                            <tr key={c.cuil} style={{borderBottom: "1px solid #e5e7eb", transition: "background 0.2s"}}>
                                                <td style={{padding: "1rem"}}>{formatCuil(c.cuil)}</td>
                                                <td style={{padding: "1rem"}}>{`${c.apellido}, ${c.nombre}`}</td>
                                                <td style={{padding: "1rem"}}>{c.observacion || '-'}</td>
                                                <td className="text-center" style={{padding: "1rem"}}>
                                                    <button
                                                        className="btn btn-sm btn-primary d-inline-flex align-items-center gap-2 me-2"
                                                        onClick={() => verDetalleCliente(c.cuil)}
                                                        style={{
                                                            borderRadius: "8px",
                                                            padding: "0.5rem 1rem",
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        <i className="bi bi-eye"></i> Ver Detalle
                                                    </button>
                                                    <button
                                                        className="btn btn-sm d-inline-flex align-items-center gap-2"
                                                        onClick={() => abrirModalReactivar(c)}
                                                        style={{
                                                            background: "var(--gradient-success)",
                                                            color: "white",
                                                            border: "none",
                                                            borderRadius: "8px",
                                                            padding: "0.5rem 1rem",
                                                            fontWeight: 500,
                                                            boxShadow: "var(--shadow-sm)"
                                                        }}
                                                    >
                                                        <i className="bi bi-arrow-counterclockwise"></i> Reactivar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>

                                {clientes.length === 0 && (
                                    <div className="text-center py-5">
                                        <i className="bi bi-inbox" style={{fontSize: "4rem", color: "#d1d5db"}}></i>
                                        <p className="mt-3 text-muted">No se encontraron clientes inactivos con los filtros aplicados.</p>
                                    </div>
                                )}

                                {totalPages > 0 && (
                                    <div className="d-flex justify-content-center py-3 border-top">
                                        <Pagination
                                            count={totalPages}
                                            page={page + 1}
                                            onChange={(_e, value) => setPage(value - 1)}
                                            color="primary"
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal Moderno de Reactivación */}
            {modalOpen && clienteSeleccionado && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-start"
                    style={{
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 1050,
                        overflowY: 'auto',
                        padding: '4rem 1rem',
                    }}
                >
                    <div
                        className="modal-content rounded-4 shadow-lg animate__animated animate__fadeInDown"
                        style={{
                            maxWidth: '550px',
                            width: '100%',
                            backgroundColor: '#fff',
                            position: 'relative',
                            maxHeight: '85vh',
                            overflowY: 'auto',
                            margin: 'auto',
                            border: "none"
                        }}
                    >
                        {/* Header con gradiente verde */}
                        <div style={{
                            background: "var(--gradient-success)",
                            padding: "1.5rem 2rem",
                            color: "white",
                            borderRadius: "16px 16px 0 0",
                            position: "relative"
                        }}>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-3">
                                    <i className="bi bi-arrow-clockwise" style={{fontSize: "2rem"}}></i>
                                    <h5 className="mb-0 fw-bold">Reactivar Cliente</h5>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() => setModalOpen(false)}
                                    style={{
                                        background: "rgba(255,255,255,0.2)",
                                        borderRadius: "8px",
                                        padding: "0.5rem"
                                    }}
                                ></button>
                            </div>
                            {/* Círculo decorativo */}
                            <div style={{
                                position: "absolute",
                                top: "-20px",
                                right: "40px",
                                width: "80px",
                                height: "80px",
                                borderRadius: "50%",
                                background: "rgba(255,255,255,0.1)",
                                backdropFilter: "blur(10px)"
                            }}></div>
                        </div>

                        <div className="modal-body p-4">
                            {/* Información del Cliente */}
                            <div style={{
                                background: "var(--success-bg)",
                                padding: "1.25rem",
                                borderRadius: "12px",
                                marginBottom: "1.5rem",
                                border: "2px solid #86efac"
                            }}>
                                <p className="mb-2" style={{fontSize: "1.05rem"}}>
                                    <strong style={{color: "#166534"}}>CUIL:</strong> {formatCuil(clienteSeleccionado.cuil)}
                                </p>
                                <p className="mb-0" style={{fontSize: "1.05rem"}}>
                                    <strong style={{color: "#166534"}}>Nombre:</strong> {apellidoNombre(clienteSeleccionado.apellido, clienteSeleccionado.nombre)}
                                </p>
                            </div>

                            {/* Campo de Observación */}
                            <div className="mt-3">
                                <label
                                    htmlFor="observacionReactivar"
                                    className="form-label fw-semibold"
                                    style={{ fontSize: "0.95rem" }}
                                >
                                    Ingrese una observación para la reactivación:
                                </label>
                                <textarea
                                    id="observacionReactivar"
                                    className="form-control"
                                    rows="4"
                                    value={observacion}
                                    onChange={(e) => setObservacion(e.target.value)}
                                    placeholder="Escriba el motivo de la reactivación..."
                                    style={{ resize: 'none', 
                                        border: '2px solid #e5e7eb',
                                        padding: '0.75rem',
                                        fontFamily: 'var(--font-family-base)' }}
                                />
                            </div>
                        </div>

                        {/* Footer con botones */}
                        <div className="modal-footer d-flex justify-content-end gap-2 p-3" style={{
                            borderTop: "2px solid #f3f4f6",
                            background: "#fafafa"
                        }}>
                            <button
                                className="btn"
                                onClick={() => setModalOpen(false)}
                                style={{
                                    background: "white",
                                    color: "#6b7280",
                                    border: "2px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "0.625rem 1.5rem",
                                    fontWeight: 500,
                                    transition: "all 0.2s"
                                }}
                            >
                                Cancelar
                            </button>
                            <button 
                                className="btn"
                                onClick={confirmarReactivar}
                                style={{
                                    background: "var(--gradient-success)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "10px",
                                    padding: "0.625rem 1.5rem",
                                    fontWeight: 600,
                                    boxShadow: "var(--shadow-md)"
                                }}
                            >
                                <i className="bi bi-check-circle me-2"></i>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}






            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
            </div>
        </div>
    );
}

export default ListadoClientesInactivos;
